import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { pageMeta } from '../lib/seo';

const PrivacyPage = () => {
  return (
    <MainLayout
      title={pageMeta.privacy.title}
      description={pageMeta.privacy.description}
      keywords={pageMeta.privacy.keywords}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-primary-text-dark mb-8">
          Datenschutzerklärung
        </h1>

        <div className="prose prose-lg max-w-none">
          <div className="bg-primary-blue-light/30 rounded-xl p-6 mb-8">
            <p className="text-sm text-primary-text-muted mb-0">
              <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE')}
            </p>
          </div>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">1. Datenschutz auf einen Blick</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Allgemeine Hinweise</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
              unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Datenerfassung auf dieser Website</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können
              Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <p className="text-primary-text-muted leading-relaxed mb-4">
              <strong>Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um
              Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer
              Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten
              (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            </p>

            <p className="text-primary-text-muted leading-relaxed mb-4">
              <strong>Wofür nutzen wir Ihre Daten?</strong><br />
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere
              Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">2. Hosting und Content Delivery Networks (CDN)</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Microsoft Azure</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Wir hosten unsere Website bei Microsoft Azure. Anbieter ist die Microsoft Corporation, One Microsoft Way,
              Redmond, WA 98052-6399, USA. Details entnehmen Sie der Datenschutzerklärung von Microsoft Azure:
              https://privacy.microsoft.com/de-de/privacystatement.
            </p>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Verwendung von Microsoft Azure erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein
              berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Datenschutz</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
              Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br />
              <br />
              SENKAY Personal & Logistik<br />
              Hilal Kaygisiz<br />
              Georg-Maurer-Weg 11<br />
              80995 München<br />
              Deutschland<br />
              <br />
              Telefon: +49 177 6276603<br />
              E-Mail: kontakt@senkay-personallogistik.de<br />
              <br />
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine
              bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
              Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Recht auf Datenübertragbarkeit</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
              automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format
              aushändigen zu lassen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">4. Datenerfassung auf dieser Website</h2>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Cookies</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und richten auf
              Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </p>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Server-Log-Dateien</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien,
              die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc pl-6 mb-4 text-primary-text-muted">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>

            <h3 className="text-xl font-semibold text-primary-text-dark mb-3">Kontaktformular</h3>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
              Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">5. Ihre Rechte</h2>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Sie haben jederzeit das Recht:
            </p>
            <ul className="list-disc pl-6 mb-4 text-primary-text-muted">
              <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten</li>
              <li>Die Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten zu verlangen</li>
              <li>Die Löschung Ihrer bei uns gespeicherten Daten zu verlangen</li>
              <li>Die Einschränkung der Verarbeitung Ihrer Daten zu verlangen</li>
              <li>Der Verarbeitung Ihrer Daten zu widersprechen</li>
              <li>Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten</li>
            </ul>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};

export default PrivacyPage;
